import * as React from 'react';
import {
  Popover, Container, Divider, Card, CardContent, Box, Typography
} from '@mui/material'

import InstagramIcon from '@mui/icons-material/Instagram';
import { useTranslation } from "react-i18next";

export default ({SearchCard, children, sx, counter}) => {

    const { t } = useTranslation();
 
    return <Box sx={{flex: 1, backgroundColor: (theme) => theme.palette.background.default}}>
        <Box sx={{background: "#a73ef7", height: '50vh', width: "100%", position: "fixed", zIndex: -1}} />
        <Box sx={{background: "linear-gradient(180deg, #a73ef7 0%, #a73ef7 20%, #b257f7 80%, #b257f7 100%)"}} width="100%">
            <Container maxWidth="sm" sx={{color:"white", zIndex: 1}}>
                <Typography variant="h4" fontSize="20"  fontWeight="bold" sx={{pt: 15, textAlign: "center"}}>
                    Padelstats.be
                </Typography>
                <Box display="flex" justifyContent="center"alignItems="center" sx={{mt: 0, mb: 0 }}>
                <Box height={5} width={30} alignSelf="center" backgroundColor="white" borderRadius={10} display="flex"></Box>
                </Box>
                <Typography variant="h6" fontWeight="light" sx={{mt: 2, textAlign: "center"}}>
                    {t("pagewrapper.description")}
                </Typography>
                <Typography variant="h6" fontWeight="light" sx={{textAlign: "center", display:"flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap"}}>
                    <a style={{fontWeight: "bold", display:"flex", alignItems: "center", justifyContent: "center", color: "inherit", textDecoration: "none"}} href="https://www.instagram.com/padelstats.be/"><InstagramIcon/>padelstats.be</a>!
                </Typography>

                <Box sx={{height: 330, pt: 3}}>
                {SearchCard ? <><SearchCard/>
                {counter != null ? <Typography variant="caption" fontWeight="light" sx={{mt: 2, ml: 2, textAlign: "center"}}>
                    {t("pagewrapper.searchedToday", {count: counter["report"]})}
                </Typography>: null}</> : null}
                </Box>
                
            </Container>
        </Box>

    
    <Container maxWidth="sm" sx={{...sx}}>

        {children}

    </Container>

</Box>}

        


